module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-W-drill-received-shadow.113ad67e.png";